import {ApiError} from '@treatwell/ui';
import type {TFunction} from 'react-i18next';
import type {RegisterErrorResponse} from '../../../../../api/register';

export const ACCOUNT_ALREADY_EXISTS_ERROR = 'ACCOUNT_ALREADY_EXISTS';

export function getRegisterError(error: unknown, t: TFunction) {
  const generic = {message: t('register.errors.generic')};
  if (!(error instanceof ApiError)) {
    return generic;
  }

  try {
    const body = JSON.parse(error.message) as RegisterErrorResponse;
    if (body.errors?.includes('EMAIL_INVALID')) {
      return {message: t('register.errors.emailInvalid')};
    }
    if (body.errors?.includes(ACCOUNT_ALREADY_EXISTS_ERROR)) {
      return {
        type: ACCOUNT_ALREADY_EXISTS_ERROR,
        message: t('register.errors.accountAlreadyExists'),
      };
    }
  } catch {
    // not parseable JSON - fall through to the generic message
  }

  return generic;
}
